import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import Home from "@/pages/Home";
import Success from "@/pages/Success";
import Admin from "@/pages/Admin";
import Wheel from "@/pages/Wheel";
import { track } from "@/lib/analytics";

function RouteTracker() {
  const location = useLocation();
  useEffect(() => {
    // Pas de tracking sur l'admin pour ne pas polluer les stats
    if (location.pathname.startsWith("/admin")) return;
    track("pageview", { path: location.pathname + location.hash });
  }, [location.pathname, location.hash]);
  return null;
}

function App() {
  return (
    <div className="App font-body">
      <CartProvider>
        <BrowserRouter>
          <RouteTracker />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/success" element={<Success />} />
            <Route path="/jeu" element={<Wheel />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          position="top-center"
          toastOptions={{
            style: {
              background: "#14230A",
              color: "#FDF0DF",
              border: "2px solid #14230A",
              borderRadius: 0,
              fontFamily: "'Barlow Condensed', sans-serif",
              fontWeight: 600,
              letterSpacing: "0.05em",
            },
          }}
        />
      </CartProvider>
    </div>
  );
}

export default App;
